import { render } from "./F.vue?vue&type=template&id=bfd254f8"
import script from "./F.vue?vue&type=script&lang=js"
export * from "./F.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__